import $ from 'jquery';
import Cache from 'root/cache';
import Collection_Feedback from 'collection/feedback';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    show_limit: 5,
    is_loaded: false,

    events: {
        'click .view-feedback': 'onViewFeedback'
    },

    dom_handlers: {
        onViewFeedback: function(e) {
            e.preventDefault();

            var feedback_id = $(e.currentTarget).data('val');
            Modals.openFeedback(feedback_id, undefined, this.collection.get(feedback_id));
        }
    },

    load: function() {
        Cache.app.request({
            action: 'feedback/search',
            data: {
                type: 'design',
                limit: 5,
                sort_type: 'desc',
                sort_order: 'time'
            },
            cache: 200, // cache for 200 seconds, so clicking around the site doesn't keep reloading this
            success: (response) => {
                this.is_loaded = true;

                this.collection = new Collection_Feedback(response.feedback);
                this.render();
            }
        });
    },

    render: function() {
        var content = '';

        if (!this.is_loaded) {
            content = '<div class="loader loader-small" style="padding:80px 24px;"></div>';
        } else {
            if (this.collection.length === 0) {
                content += '<div class="text-info text-align-center italic" style="padding:80px 24px;">You haven\'t uploaded any <a class="navigation text-info" href="' + Cache.getDefaultProject().get('project_key') + '/feedback/design/">design files</a>.</div>';
            } else {
                content +=
                '<table class="medium">' +
                    '<tr>' +
                        '<th>Name</th>' +
                        '<th>Type</th>' +
                        '<th>Uploaded By</th>' +
                        '<th class="text-align-right">Date Uploaded</th>' +
                    '</tr>';


                this.collection.each((model) => {
                    var design_type = '';
                    var design_icon = '';
                    var uploader    = '';

                    if (model.isPdf()) {
                        design_type = 'PDF';
                        design_icon = '<i class="far fa-fw fa-file-pdf"></i>';
                    } else if (model.isVideoUpload()) {
                        design_type = 'Video';
                        design_icon = '<i class="far fa-fw fa-film-alt"></i>';
                    } else {
                        design_type = 'Design File';
                        design_icon = '<i class="far fa-fw fa-image"></i>';
                    }

                    uploader = Cache.user.get(model.get('uploader_user_id'));

                    content +=
                    '<tr>' +
                        '<td>' +
                            '<a class="view-feedback no-underline hover-underline" data-val="' + model.id + '" href="#">' +
                                '<span class="margin-right-4">' + design_icon + '</span>' + Util.trim(model.escape('page'), '20') +
                            '</a>' +
                        '</td>' +
                        '<td>' + design_type + '</td>' +
                        '<td>' +
                            '<div class="flex-start">' +
                                (uploader ?
                                '<img class="user-24 margin-right-4" src="' + uploader.getAvatar(24) +'">' +
                                '<span>' + uploader.escape('name') + '</span>' :

                                '<img class="user-24 margin-right-4" src="' + Util.gravatar(model.get('email'), 24, model.get('name')) +'">' +
                                '<span>' + model.escape('name') + '</span>') +
                            '</div>' +
                        '</td>' +
                        '<td class="text-align-right">' + Util.moment(model.get('time')) + '</td>' +
                    '</tr>';
                });

                if (this.collection.length < this.show_limit) {
                    for (var i = 0; i < this.show_limit - this.collection.length; i++) {
                        content += '<tr class="emtpy"><td colspan="4" height="48"></td></tr>';
                    }
                }

                content +=
                '<tr class="empty">' +
                    '<td colspan="4" align="right"><a href="/' + Cache.getDefaultProject().get('project_key') + '/feedback/design" class="primary navigation"><b>View More</b></a></td>' +
                '</tr>';

                content += '</table>';
            }
        }

        this.$el.html(content);

        if (!this.is_loaded) {
            this.load();
        }

        return this;
    }
});